export const email_RE =
  /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
export const mobile_RE = /^[6-9]{1}[0-9]{9}$/;
export const number_RE = /^[0-9\b]+$/;
export const name_RE = /^[a-zA-Z ]{2,30}$/;
export const paymentProof_RE = /(\.jpg|\.jpeg|\.png|\.pdf)$/i;
